var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompaniesIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.8194 9.33333H34.2224C18.335 9.33333 9.3335 18.3348 9.3335 34.2222V77.7778C9.3335 93.6652 18.335 102.667 34.2224 102.667H77.8194C93.7068 102.667 102.667 93.6652 102.667 77.7778V34.2222C102.667 18.3348 93.7068 9.33333 77.8194 9.33333Z",
    fill: "#136BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3871 43.7218C32.2715 43.7218 30.5293 45.464 30.5293 47.6211V79.6862C30.5293 81.8018 32.2715 83.544 34.3871 83.544C36.5441 83.544 38.2863 81.8018 38.2863 79.6862V47.6211C38.2863 45.464 36.5441 43.7218 34.3871 43.7218Z",
    fill: "#136BFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1654 28.4153C54.0498 28.4153 52.3076 30.1575 52.3076 32.3145V79.6864C52.3076 81.8019 54.0498 83.5442 56.1654 83.5442C58.3224 83.5442 60.0647 81.8019 60.0647 79.6864V32.3145C60.0647 30.1575 58.3224 28.4153 56.1654 28.4153Z",
    fill: "#136BFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6532 60.6464C75.4961 60.6464 73.7539 62.3886 73.7539 64.5457V79.6864C73.7539 81.802 75.4961 83.5442 77.6117 83.5442C79.7687 83.5442 81.511 81.802 81.511 79.6864V64.5457C81.511 62.3886 79.7687 60.6464 77.6532 60.6464Z",
    fill: "#136BFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesIcon1);
export default __webpack_public_path__ + "static/media/companies-icon-1.cbb87ecefcc6d49ad9b44ea050aefd70.svg";
export { ForwardRef as ReactComponent };